export default __webpack_public_path__ + "static/media/logo-sito.0ca362ef.png";